import { render } from "./main-layout.vue?vue&type=template&id=670f10bd&scoped=true"
import script from "./main-layout.vue?vue&type=script&lang=js"
export * from "./main-layout.vue?vue&type=script&lang=js"

import "./main-layout.vue?vue&type=style&index=0&id=670f10bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670f10bd"]])

export default __exports__